import _slicedToArray from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
import { useIsomorphicEffect } from '../use-isomorphic-effect/use-isomorphic-effect.js';

function getOS() {
  if (typeof window === "undefined") {
    return "undetermined";
  }

  var userAgent = window.navigator.userAgent;
  var macosPlatforms = /(Macintosh)|(MacIntel)|(MacPPC)|(Mac68K)/i;
  var windowsPlatforms = /(Win32)|(Win64)|(Windows)|(WinCE)/i;
  var iosPlatforms = /(iPhone)|(iPad)|(iPod)/i;

  if (macosPlatforms.test(userAgent)) {
    return "macos";
  }

  if (iosPlatforms.test(userAgent)) {
    return "ios";
  }

  if (windowsPlatforms.test(userAgent)) {
    return "windows";
  }

  if (/Android/i.test(userAgent)) {
    return "android";
  }

  if (/Linux/i.test(userAgent)) {
    return "linux";
  }

  return "undetermined";
}

function useOs() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    getValueInEffect: true
  };

  var _useState = useState(options.getValueInEffect ? "undetermined" : getOS()),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useIsomorphicEffect(function () {
    if (options.getValueInEffect) {
      setValue(getOS);
    }
  }, []);
  return value;
}

export { useOs };